// extracted by mini-css-extract-plugin
export default {"menu_container":"Navbar_menu_container__UzqUb","menu_logo":"Navbar_menu_logo__7YGnQ","menu":"Navbar_menu__Imi9Z","right_wrapper":"Navbar_right_wrapper__8f0hl"};